import React, { useState, useEffect, useRef } from 'react'
import { useParams, useHistory, Link } from 'react-router-dom'
import ReactSummernote from 'react-summernote'
import {
  Common,
  Permissionkeys,
  Title,
  SimpleReactValidator,
  API,
  HttpService,
  toast,
  Messages,
  getBase64,
  swal,
  Nestable,
  DateFormat,
  Spinner
  // QRCode
} from '../../../config/react'
import DataTable from 'react-data-table-component'

const AddSection = () => {
  var ImageArry = []
  const desiredOrder = ['Rings', 'Bracelets', 'Pendants', 'Necklaces', 'Earrings', 'Studs']
  const [Products, setProducts] = useState({ products_skus: [] })
  const urlParams = useParams()
  const history = useHistory()
  const validator = useRef(new SimpleReactValidator())
  const [IsAuth, setIsAuth] = useState(false)
  const [isForceUpdate, setForceUpdate] = useState(false)
  const [CheckTemplate, setCheckTemplate] = useState('')
  const [SelectedTemplateid, setSelectedTemplateid] = useState(null)
  const [Templates, setTemplates] = useState([])
  const [BestsellerItem, setBestsellerItem] = useState([])
  const [TotalSection, setTotalSection] = useState(null)
  const [OptionList, setOptionList] = useState([])
  const [totalRows, settotalRows] = useState()
  const [BestsellerOptions, setBestsellerOptions] = useState()
  const [selectedAccordian, setselectedAccordian] = useState(0)
  const [currentPage, setCurrentPage] = useState(1)
  const [loading, setLoading] = useState(true)
  const canvasRef = useRef(null)
  const [Inputs, setInputs] = useState({
    id: 0,
    section_name: '',
    sub_title: '',
    sort_order: '',
    status: 0,
    template_id: 0,
    content: '',
    category_id: 0,
    options: []
  })

  const DefaultFilters = {
    page: 1,
    search: '',
    page_size: 10,
    sort_column: '',
    sort_direction: ''
  }

  const [CustomFilters, setCustomFilters] = useState(DefaultFilters)
  // const [BestSellersItem, setBestSellersItem] = useState([])
  const [Bestsellercategory, setBestsellercategory] = useState([])

  useEffect(() => {
    if (urlParams.id !== undefined) GetSectionById()
  }, [CustomFilters])

  const GetContent = () => {
    const param = {
      priceColumn: 'US_price',
      is_admin: 1,
      section_id: urlParams.id
    }
    setLoading(true)
    HttpService.postApi(API.getHomeContent, param).then((response) => {
      setLoading(false)
      try {
        const data = response.data.result[1]?.filter((x) => x.template_name === 'best_seller')[0]
          .content
        setBestsellercategory(data)
        // const products = data
        //   ?.filter((x) => x.category_name === 'Rings')
        //   .map((x) => x.products)
        //   .map((item) => item)
        // setBestSellersItem(products[0])
      } catch (err) {
        console.log(err)
      }
    })
  }
  const columns = [
    {
      name: 'Title',
      sortable: true,
      sortField: 'title',
      selector: (row) => row.title
    },
    {
      name: 'Link Type',

      selector: (row) => row.link_type
    },
    {
      name: 'Value',

      selector: (row) => (row.value === null ? ' -' : row.value)
    },
    {
      name: 'Created Date',
      sortable: true,
      sortField: 'created_at',
      selector: (row) => <DateFormat value={row.created_at}></DateFormat>
    },
    {
      name: 'Status',
      selector: (row) => (row.status ? 'Active' : 'Inactive')
    },
    {
      name: 'Action',
      selector: (row) => (
        <div className="action-btn">
          <Link
            to={'/widgets/section-option/edit/' + row.id + '&' + urlParams.id}
            className="text-dark"
            title="Edit"
          >
            <i
              className="fa fa-pencil-square-o"
              aria-hidden="true"
            ></i>{' '}
          </Link>
          <Link
            onClick={(e) => DeleteSectionOption(e, row.id, urlParams.id)}
            className="text-dark"
            title="Delete"
          >
            <i
              className="fa fa-trash-o"
              aria-hidden="true"
            ></i>{' '}
          </Link>
          {/* <Link
            to="#"
            onClick={(e) => generateQRCode(e, row.link, row.link_type, row.title)}
            className="text-dark"
            title="Download QR Code"
          >
            <i
              className="fa fa-download"
              aria-hidden="true"
            ></i>{' '}
          </Link> */}
        </div>
      )
    }
  ]
  useEffect(() => {
    document.title = Title.AddSection
    if (!Common.validatePermission(Permissionkeys.Section)) {
      history.push('/')
    }
    setIsAuth(true)
    if (urlParams.id !== undefined) {
      document.title = Title.EditSection
      GetSectionById()
    }
    GetTemplatesList()
    getBestSellerItems()
  }, [urlParams.id])

  const handleInputChanges = (prop) => (event) => {
    if (prop === 'status') {
      setInputs({ ...Inputs, [prop]: event.target.checked })
    } else {
      setInputs({ ...Inputs, [prop]: event.target.value })
    }
    setForceUpdate(!isForceUpdate)
  }

  const handleTemplateChanges = (prop) => (event) => {
    const TempName = Templates.filter((x) => x.id === parseInt(event.currentTarget.value))[0].name
    if (
      ((TempName !== null || TempName !== undefined) && TempName === 'custom_html') ||
      ((TempName !== null || TempName !== undefined) && TempName === 'best_seller')
    )
      setCheckTemplate(TempName)
    else setCheckTemplate('')
    setInputs({ ...Inputs, template_id: parseInt(event.target.value) })
    setForceUpdate(!isForceUpdate)
  }
  const handleCategoryChanges = (prop) => (event) => {
    if (urlParams.id !== undefined) {
      const options = BestsellerOptions.filter((x) => x.parentid === parseInt(event.target.value))
      setInputs({
        ...Inputs,
        options: options,
        category_id: parseInt(event.target.value)
      })
    } else {
      setInputs({ ...Inputs, category_id: parseInt(event.target.value), options: [] })
    }
    setForceUpdate(!isForceUpdate)
  }

  const handleEditorChange = (e) => {
    setInputs({ ...Inputs, content: e })
    setForceUpdate(!isForceUpdate)
  }

  window.addEventListener('fileUploadWithPreview:imagesAdded', function (e) {
    const imageType = e.detail.cachedFileArray[0].type
    const type = e.detail.cachedFileArray[0].type.split('/')[1]
    const size = e.detail.cachedFileArray[0].size
    const Id = e.detail.uploadId.split('_')[2]
    if (imageType === 'image/jpeg' || imageType === 'image/jpg' || imageType === 'image/png') {
      if (size <= 2097152) {
        getBase64(e.detail.cachedFileArray[0], (result) => {
          ImageArry.push({ imageId: Id, image: result, type: '.' + type })
        })
      }
    }
  })

  window.addEventListener('fileUploadWithPreview:clearButtonClicked', function (e) {
    if (ImageArry.length > 0) {
      const Id = e.detail.uploadId.split('_')[2]
      ImageArry = ImageArry.filter((x) => x.imageId !== Id)
    }
  })

  const GetSectionById = () => {
    const param = {
      id: urlParams.id,
      page: CustomFilters.page,
      search: CustomFilters.search,
      page_size: CustomFilters.page_size,
      sort_column: CustomFilters.sort_column,
      sort_direction: CustomFilters.sort_direction
    }

    HttpService.postApi(API.GetSectionById, param).then((response) => {
      if (response.data.result) {
        const data = response.data.result[0][0]
        const sectionOptions = response.data.result[2]
        if (data !== undefined) {
          setInputs({
            id: data.id,
            section_name: data.section_name,
            sub_title: data.sub_title,
            sort_order: data.sort_order,
            status: data.status,
            template_id: data.template_id,
            content: data.content
          })

          if (data.template_id === 5) {
            GetContent()
            setBestsellerOptions(convertData(JSON.parse(data.content)))
            setProducts({ ...Products, products_skus: JSON.parse(data.content) })
          }
          if (sectionOptions.length !== 0) {
            setOptionList(sectionOptions)
          } else {
            setOptionList(0)
          }
          settotalRows(response.data.result[1][0].total)
          if (data.template_id === 1) {
            setCheckTemplate('three_column')
          } else if (data.template_id === 2) {
            setCheckTemplate('slider')
          } else if (data.template_id === 3) {
            setCheckTemplate('two_column')
          } else if (data.template_id === 4) {
            setCheckTemplate('custom_html')
          } else if (data.template_id === 5) {
            setCheckTemplate('best_seller')
          } else if (data.template_id === 6) {
            setCheckTemplate('one_column')
          }
          if (sectionOptions.length !== 0) {
            setTotalSection(sectionOptions.filter((item) => item.status).length)
          } else {
            setTotalSection(0)
          }
          setSelectedTemplateid(data.template_id)
        }
      }
    })
  }

  const GetTemplatesList = () => {
    setLoading(true)
    HttpService.postApi(API.GetTemplatesList, {}).then((response) => {
      setLoading(false)
      setTemplates(response.data.result)
      setForceUpdate(!isForceUpdate)
    })
  }
  const getBestSellerItems = () => {
    setLoading(true)
    HttpService.getApi(API.BestsellerCategory).then((response) => {
      setLoading(false)
      const data = response.data.result[0]
      setBestsellerItem(data)

      setForceUpdate(!isForceUpdate)
    })
  }

  const styles = {
    position: 'relative',
    padding: '10px 10px',
    fontSize: '15px',
    border: '1px solid #f9fafa',
    background: '#f9fafa',
    cursor: 'move'
  }
  const addBestSellerOption = (e) => {
    e.preventDefault()
    let options = Inputs.options
    if (options === undefined) options = []
    options.push({
      parentid: Inputs.category_id,
      id: Math.floor(1000 + Math.random() * 9000),
      value: '',
      sort_order: options.length > 0 ? Math.max(...options.map((o) => o.sort_order)) + 1 : 0
    })
    setInputs({ ...Inputs, options: options })
    setForceUpdate(!isForceUpdate)
  }
  const handleDelete = (i) => (e) => {
    e.preventDefault()
    let options = [...Inputs.options]
    options = options.filter((x) => x.id !== i)
    Inputs.options = options
    const data = Object.groupBy(options, ({ parentid }) => parentid)
    const products = []
    for (const key in data) {
      const skus = data[key]
      const sku = []
      for (const key in skus) {
        sku.push(skus[key].value)
      }
      products.push({ categoryid: key, products: sku })
    }

    if (Products.length !== 0 && urlParams.id !== undefined) {
      if (products.length !== 0) {
        const data = Products.products_skus
          .map((x) => x[0].categoryid === products[0].categoryid)
          .findIndex((x) => x)
        Products.products_skus[data][0].products = products[0].products
      } else {
        const data = Products.products_skus
          .map((x) => parseInt(x[0].categoryid) === Inputs.category_id)
          .findIndex((x) => x)
        Products.products_skus[data][0].products = []
      }
    }
    setForceUpdate(!isForceUpdate)
  }
  const changeOptionValue = (item) => {
    const attributeOptions = []
    item.items.map((item, index) => {
      attributeOptions.push({ option_id: item.id, value: item.value, sort_order: index })
      return true
    })

    setInputs({ ...Inputs, options: attributeOptions })
    if (urlParams.id !== null) {
      const param = {
        items: attributeOptions
      }

      HttpService.postApi(API.ChangeCategoryAttributeOrder, param).then((response) => {})
    }
  }
  const handleText = (i) => (e) => {
    const options = [...Inputs.options]
    const index = options.findIndex((x) => x.value === i)
    options[index] = {
      parentid: Inputs.category_id,
      id: index,
      value: e.target.value.trim(),
      sort_order: options[index].sort_order !== undefined ? options[index].sort_order : 0
    }

    const data = Object.groupBy(options, ({ parentid }) => parentid)
    const products = []
    for (const key in data) {
      const skus = data[key]
      const sku = []
      for (const key in skus) {
        sku.push(skus[key].value)
      }
      products.push({ categoryid: key, products: sku })
    }

    if (products.length !== 0) {
      setProducts({ ...Products, skus: products })
      setInputs({ ...Inputs, options: options })
    }

    if (products.length !== 0 && urlParams.id !== undefined) {
      const data = Products.products_skus
        .map((x) => x[0].categoryid === products[0].categoryid)
        .findIndex((x) => x)
      if (data !== -1) {
        Products.products_skus[data][0].products = products[0].products
      } else {
        Products.products_skus.push(products)
      }
    } else if (products.length !== 0) {
      const index = Products.products_skus
        .map((x) => x[0].categoryid === products[0].categoryid)
        .findIndex((x) => x)
      if (index !== -1) {
        Products.products_skus[index][0].products = products[0].products
      } else {
        Products.products_skus.push(products)
      }
    }
    setForceUpdate(!isForceUpdate)
  }
  const renderItem = (item) => {
    return (
      <div style={styles}>
        <div className="d-flex form-group mb-0">
          <div className="w-100 pr-0">
            <input
              type="text"
              title="itemskus"
              className="form-control col-md-12"
              placeholder="Enter Child Sku"
              onChange={handleText(item.item.value)}
              value={item.item.value}
            />
          </div>
          <div className="col-auto pl-2 pr-0">
            <button
              className="btn btn-danger input-btn btn-block"
              onClick={handleDelete(item.item.id)}
            >
              X
            </button>
          </div>
        </div>
      </div>
    )
  }

  const SubmitForm = (e) => {
    if (!validator.current.allValid()) {
      validator.current.showMessages()
      setForceUpdate(!isForceUpdate)
      return
    }
    const obj = {
      custom: ''
    }
    if (Inputs.template_id === 5) {
      obj.custom = JSON.stringify(Products.products_skus)
    } else {
      obj.custom = Inputs.content
    }
    const param = {
      _id: Inputs.id,
      _section_name: Inputs.section_name,
      _sub_title: Inputs.sub_title,
      _status: Inputs.status ?? 0,
      _sort_order: Inputs.sort_order === '' ? null : Inputs.sort_order,
      _template_id: Inputs.template_id,
      _custom: obj.custom,
      _page: CustomFilters.page,
      _search: CustomFilters.search,
      _page_size: CustomFilters.page_size,
      _sort_column: CustomFilters.sort_column,
      _sort_direction: CustomFilters.sort_direction
    }
    setLoading(true)
    HttpService.postApi(API.SetSection, param).then((response) => {
      setLoading(false)
      if (response.data.message) {
        const invalidSkus = response.data.message.invalidSkusString
        const duplicateSkus = response.data.message.duplicateSkusString

        let alertText = ''
        if (invalidSkus) {
          alertText += `Invalid SKU(s): ${invalidSkus}\n`
        }
        if (duplicateSkus) {
          alertText += `Duplicate SKU(s): ${duplicateSkus}`
        }

        swal({
          title: 'Error',
          text: alertText.trim()
        })
        toast.warning(response.data.message)
        setForceUpdate(!isForceUpdate)
        GetSectionById()
        return
      }
      if (urlParams.id !== undefined) {
        toast.success(Messages.sectionupdate)
        if (SelectedTemplateid !== undefined && Inputs.template_id !== SelectedTemplateid) {
          clearSectionOption()
        }
      } else toast.success(Messages.sectionadd)
      setForceUpdate(!isForceUpdate)
      history.push('/widgets/section')
    })
  }
  const data = { sid: urlParams.id }
  const handleAddoption = (e) => {
    history.push({ pathname: '/widgets/section-option/Add/', state: data })
  }

  const DeleteSectionOption = (e, id, sid) => {
    swal(Messages.SwalDeleteProp).then(function (isConfirm) {
      if (isConfirm) {
        const param = {
          _id: id,
          _section_id: sid
        }
        HttpService.postApi(API.DeleteSectionItem, param).then((response) => {
          toast.success(Messages.RecordDeleted)
          GetSectionById()
        })
      }
    })
  }

  const clearSectionOption = () => {
    const param = {
      _section_id: urlParams.id
    }
    HttpService.postApi(API.ClearSectionItems, param).then((response) => {})
  }

  const handlePageChange = (e) => {
    setCurrentPage(e)
    setCustomFilters({ ...CustomFilters, page: e })
  }

  const handlePerRowsChange = (e) => {
    setCurrentPage(1)
    setCustomFilters({ ...CustomFilters, page: 1, page_size: e })
  }

  const handleSort = (e, direction) => {
    //  console.log("LN 112 Sort FIeld " + e.sortField);
    setCustomFilters({
      ...CustomFilters,
      sort_column: e.sortField,
      sort_direction: direction
    })
  }
  const subHeaderComponentMemo = React.useMemo(() => {
    return (
      <input
        name="Search"
        type="text"
        title="Search For Name."
        className="form-control col-md-3"
        placeholder="Search"
        value={CustomFilters.search}
        onChange={(e) => setCustomFilters({ ...CustomFilters, search: e.target.value })}
      />
    )
  })

  const convertData = (data) => {
    return data.flatMap((item) => {
      const parentid = parseInt(item[0].categoryid)
      return item[0].products.map((value, index) => ({
        parentid,
        id: Math.floor(1000 + Math.random() * 9000),
        value,
        sort_order: index
      }))
    })
  }
  const handleAccordionClick = (e) => {
    setselectedAccordian(e)
  }
  const preventMinus = (e) => {
    if (
      e.code === 'Minus' ||
      e.code === 'Equal' ||
      e.code === 'NumpadAdd' ||
      e.code === 'NumpadSubtract'
    ) {
      e.preventDefault()
    }
  }
  // const generateQRCode = async (e, link, linkType, title) => {
  //   const qrCodeText =
  //     linkType === 'category' || linkType === 'page'
  //       ? process.env.REACT_APP_FRONTEND_URL + link
  //       : link
  //   try {
  //     const qrCodeWidth = 300
  //     const qrCodeHeight = 300
  //     // Set canvas size before rendering the QR code
  //     const canvas = canvasRef.current
  //     canvas.width = qrCodeWidth
  //     canvas.height = qrCodeHeight

  //     // Generate QR code with the specified width and height
  //     await QRCode.toCanvas(canvas, qrCodeText, {
  //       errorCorrectionLevel: 'H',
  //       width: qrCodeWidth
  //     })

  //     const dataURL = canvas.toDataURL('image/png')

  //     const link = document.createElement('a')
  //     link.href = dataURL
  //     link.download = title + '.png'
  //     document.body.appendChild(link)
  //     link.click()
  //     document.body.removeChild(link)
  //   } catch (error) {
  //     console.error('Error generating QR code:', error)
  //   }
  // }
  return !IsAuth || loading ? (
    <Spinner />
  ) : (
    <div className="content-wrapper pb-0">
      <div className="page-header">
        <h3 className="page-title mb-0">
          {' '}
          {urlParams.id !== undefined ? Title.EditSection : Title.AddSection}{' '}
        </h3>
        <div className="btn-group">
          <Link
            className="btn btn-dark btn-fw rounded mr-2"
            to="/widgets/section"
          >
            {' '}
            Back{' '}
          </Link>
        </div>
      </div>
      <div className="row">
        <div className="col-12 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <form
                className="forms-sample"
                autoComplete="off"
              >
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>Section Name</label>
                      <input
                        type="text"
                        maxLength="255"
                        className="form-control"
                        name="section_name"
                        onChange={handleInputChanges('section_name')}
                        onKeyUp={handleInputChanges('section_name')}
                        onBlur={() => validator.current.showMessageFor('section_name')}
                        value={Inputs.section_name}
                        placeholder="Section Name"
                      />
                      {validator.current.message('Section Name', Inputs.section_name, 'required', {
                        className: 'error'
                      })}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>Sub Title</label>
                      <input
                        type="text"
                        className="form-control"
                        name="sub_title"
                        onChange={handleInputChanges('sub_title')}
                        onKeyUp={handleInputChanges('sub_title')}
                        defaultValue={Inputs.sub_title}
                        placeholder="Sub Title"
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>Sort Order</label>
                      <input
                        type="number"
                        min={1}
                        className="form-control"
                        name="sort_order"
                        onChange={handleInputChanges('sort_order')}
                        onKeyUp={handleInputChanges('sort_order')}
                        value={Inputs.sort_order}
                        onKeyPress={preventMinus}
                        placeholder="Sort Order"
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>Select Template</label>
                      <select
                        className="form-control"
                        name="template_id"
                        onChange={handleTemplateChanges('template_id')}
                        value={Inputs.template_id}
                      >
                        <option value="">Select</option>
                        {Templates.length > 0 &&
                          Templates.map((item, index) => (
                            <option
                              key={index}
                              value={item.id}
                            >
                              {item.name}
                            </option>
                          ))}
                      </select>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div
                      className={CheckTemplate === 'best_seller' ? 'row-col-md-6 ' : 'row d-none'}
                    >
                      <div className="form-group">
                        <label>Select Category</label>
                        <div className="d-flex">
                          <select
                            className="form-control"
                            name="category_id"
                            onChange={handleCategoryChanges('category_id')}
                            value={Inputs.category_id}
                          >
                            <option value={0}>Select</option>
                            {BestsellerItem.length > 0 &&
                              BestsellerItem.map((item, index) => (
                                <option
                                  key={index}
                                  value={item.id}
                                >
                                  {item.name}
                                </option>
                              ))}
                          </select>
                          {Inputs.category_id !== 0 &&
                          Inputs.category_id !== undefined &&
                          Inputs.options.length < 4 ? (
                            <button
                              className="btn btn-primary ml-2 white-space-nowrap"
                              onClick={addBestSellerOption}
                            >
                              Add Item
                            </button>
                          ) : null}
                        </div>
                        {Inputs.category_id !== 0 && Inputs.category_id !== undefined && (
                          <p className="m-1 note">
                            Submit your changes before changing a new category.
                          </p>
                        )}
                      </div>
                      <div className="row">
                        <div className="col-md-12 mb-2">
                          {Inputs.options?.length > 0 && (
                            <Nestable
                              items={Inputs.options}
                              renderItem={renderItem}
                              onChange={changeOptionValue}
                              collapsed={false}
                              maxDepth={1}
                            />
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group ">
                      <label htmlFor="exampleInputUsername2">Status</label>
                      <div>
                        <div className="custom-control custom-switch mt-1">
                          <input
                            type="checkbox"
                            className="custom-control-input"
                            name="status"
                            onChange={handleInputChanges('status')}
                            id="EnableProduct"
                            checked={Inputs.status}
                          />
                          <label
                            className="custom-control-label"
                            htmlFor="EnableProduct"
                          >
                            {' '}
                          </label>
                        </div>
                      </div>
                    </div>
                    {}
                    <div
                      className={
                        CheckTemplate === 'best_seller' ? 'form-group mt-2 ' : 'row d-none'
                      }
                    >
                      <div
                        id="accordion"
                        className="custom-accordion"
                      >
                        {Bestsellercategory.filter((x) => x.category_name !== undefined)
                          .sort(
                            (a, b) =>
                              desiredOrder.indexOf(a.category_name) -
                              desiredOrder.indexOf(b.category_name)
                          )
                          .map((item, index) => (
                            <div
                              className="card shadow-none border-top"
                              key={index}
                            >
                              <a
                                data-toggle="collapse"
                                data-target={'#' + selectedAccordian}
                                onClick={(e) => handleAccordionClick(item.category_name)}
                                aria-expanded="true"
                                aria-controls="collapseOne"
                              >
                                <div className="card-header border-none">
                                  <label className="mb-0">{item.category_name}</label>
                                  <i className="mdi mdi-chevron-down fs-16 float-right"></i>
                                </div>
                              </a>

                              <div
                                id={item.category_name}
                                className="collapse"
                                aria-labelledby="headingOne"
                                data-parent="#accordion"
                              >
                                <table className="table table-responsive">
                                  <thead>
                                    <tr>
                                      <th>Image</th>
                                      <th>Product Name</th>
                                      <th>Sku</th>
                                      <th>Price</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {item.products.map((product, i) => (
                                      <tr key={i}>
                                        <td>
                                          <img
                                            src={product.base_image}
                                            alt={product.name}
                                          ></img>
                                        </td>
                                        <td>{product.name}</td>
                                        <td>{product.sku}</td>
                                        <td>{product.formated_price}</td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          ))}
                      </div>
                    </div>
                  </div>
                </div>

                <div className={CheckTemplate === 'custom_html' ? 'row ' : 'row d-none'}>
                  <div className="col-md-12">
                    <div className="form-group">
                      <label>Content</label>
                      <ReactSummernote
                        name="content"
                        value={Inputs.content}
                        options={{
                          height: 350,
                          dialogsInBody: true,
                          toolbar: [
                            ['style', ['style']],
                            [
                              'font',
                              [
                                'bold',
                                'underline',
                                'clear',
                                'strikethrough',
                                'superscript',
                                'subscript'
                              ]
                            ],
                            ['fontname', ['fontname']],
                            ['para', ['ul', 'ol', 'paragraph']],
                            ['table', ['table']],
                            ['insert', ['link', 'picture', 'video']],
                            ['view', ['fullscreen', 'codeview']],
                            ['height', ['height']]
                          ]
                        }}
                        onChange={(e) => {
                          handleEditorChange(e)
                        }}
                      />
                    </div>
                  </div>
                </div>

                <div
                  className={
                    urlParams.id !== null
                      ? CheckTemplate === 'custom_html' ||
                        SelectedTemplateid !== Inputs.template_id ||
                        CheckTemplate === 'best_seller'
                        ? 'row d-none'
                        : 'row'
                      : CheckTemplate === 'custom_html' || CheckTemplate === ''
                        ? 'row d-none'
                        : 'row'
                  }
                >
                  <div className="col-lg-12 grid-margin stretch-card">
                    <div className="card">
                      <div className="card-body">
                        <div className="table-responsive">
                          {(CheckTemplate === 'two_column' && TotalSection < 2) ||
                          (CheckTemplate === 'one_column' && TotalSection < 1) ||
                          CheckTemplate === 'three_column' ||
                          CheckTemplate === 'slider' ||
                          CheckTemplate === 'best_seller' ? (
                            <button
                              to="/widgets/section-option/Add/"
                              className="btn btn-primary float-right mb-2"
                              onClick={handleAddoption}
                            >
                              Add Option
                            </button>
                          ) : null}
                          {OptionList.length !== 0 ? (
                            <DataTable
                              columns={columns}
                              data={OptionList}
                              onSort={handleSort}
                              pagination
                              paginationServer
                              persistTableHead={true}
                              paginationTotalRows={totalRows}
                              paginationDefaultPage={currentPage}
                              onChangeRowsPerPage={handlePerRowsChange}
                              onChangePage={handlePageChange}
                              sortServer
                              subHeader
                              progressPending={loading}
                              progressComponent={<Spinner />}
                              subHeaderComponent={subHeaderComponentMemo}
                            />
                          ) : null}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row mt-3">
                  <div className="col-md-6">
                    <button
                      type="button"
                      onClick={SubmitForm}
                      className="btn btn-custom text-white mr-2"
                    >
                      {' '}
                      Submit{' '}
                    </button>
                    <Link
                      to="/widgets/section"
                      className="btn btn-primary mr-2"
                    >
                      Cancel
                    </Link>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <canvas
        ref={canvasRef}
        style={{ display: 'none' }}
      ></canvas>
    </div>
  )
}
export default AddSection
